import { forwardRef, useState } from 'react';
import { Field } from 'formik';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../../../users/walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    dropDownFormStyle,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import { Select } from 'chakra-react-select';

const ResourceAccountTemplateField = ({ errors, touched, templates, darkMode, onImageChange }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { autoAttendant } = walkthroughIds;
    const ChakraSelect = forwardRef((props, ref) => (
        <Select selectedOptionColor="brand" ref={ref} {...props} />
    ));
    ChakraSelect.displayName = "ChakraSelect";

    return (
        <FormControl
            isInvalid={!!errors.template && touched.template}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Template
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                       Select a predefined template to configure your Response Group.
                    </Text>
                </Box>
                <Box
                    flex="1"
                    sx={{
                        paddingTop: '15px',
                    }}
                >

                    <Field name="template">
                        {({ form }) => {
                            // Find the selected option object from templates array
                            const selectedOption = templates.find(
                                (tpl) => tpl.id === form.values.template
                            ) || null;

                            return (
                                <ChakraSelect
                                    minWidth="410px"
                                    width="100%"
                                    data-walkthroughid={autoAttendant.ufTemplate}
                                    options={templates}
                                    placeholder="Select Template"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    getOptionLabel={(i) => i.displayName || i.name}
                                    getOptionValue={(i) => i.id}
                                    chakraStyles={dropDownFormStyle(darkMode)}
                                    isLoading={form.isSubmitting}
                                    isDisabled={form.isSubmitting}
                                    value={selectedOption}
                                    onChange={(template) => {
                                        console.log('Selected template:', template);
                                        form.setFieldValue('template', template.id);
                                        form.validateField('template');
                                        // Get template object and set imagePath based on chat property
                                        const selectedTemplateObj = templates.find((a) => a.id === template.id);
                                        let path;
                                        if (selectedTemplateObj) {
                                            path = `${import.meta.env.VITE_APP_IMAGE_BASE}/images/${selectedTemplateObj.image}`;
                                            console.log('Image path:', path);
                                        } else {
                                            path = '';
                                        }
                                        if (onImageChange) {
                                            onImageChange(path); // <-- Send to parent
                                        }
                                    }}
                                    onBlur={() => {
                                        form.setFieldTouched('template', true);
                                    }}
                                />
                            );
                        }}
                    </Field>

                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="This shall create the necessary components in the Teams tenant  including Resource Accounts, Auto Attendants, Call Queues and Business Hours.  Please Adjust as appropriate in Teams Admin Center after.
Body text."
                        ariaLabel="resource-account-template-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ResourceAccountTemplateField;